import { render, staticRenderFns } from "./SettlementInvoiceView.vue?vue&type=template&id=4c5838d3&"
import script from "./SettlementInvoiceView.vue?vue&type=script&lang=js&"
export * from "./SettlementInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./SettlementInvoiceView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports